module.exports = __webpack_public_path__ + "static/img/page34.dba3cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page34.jpg
// module id = ldvd
// module chunks = 0